import * as Types from "../../../../../../types/__generated__/graphql";

import {gql} from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UserByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars["String"]["input"];
}>;

export type UserByEmailQuery = {
  __typename?: "Query";
  user?: {
    __typename?: "UnauthenticatedUserResponse";
    user?: {
      __typename?: "UnauthenticatedUser";
      anonymizedEmail?: string | null;
      id: string;
      adultPatient?: {
        __typename?: "UnauthenticatedPatient";
        anonymizedPhoneNumber?: string | null;
        id: string;
      } | null;
    } | null;
  } | null;
};

export const UserByEmailDocument = gql`
  query UserByEmail($email: String!) {
    user(email: $email) {
      user {
        anonymizedEmail
        id
        adultPatient {
          anonymizedPhoneNumber
          id
        }
      }
    }
  }
`;

/**
 * __useUserByEmailQuery__
 *
 * To run a query within a React component, call `useUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserByEmailQuery(
  baseOptions: Apollo.QueryHookOptions<UserByEmailQuery, UserByEmailQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useQuery<UserByEmailQuery, UserByEmailQueryVariables>(UserByEmailDocument, options);
}
export function useUserByEmailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<UserByEmailQuery, UserByEmailQueryVariables>,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useLazyQuery<UserByEmailQuery, UserByEmailQueryVariables>(
    UserByEmailDocument,
    options,
  );
}
export type UserByEmailQueryHookResult = ReturnType<typeof useUserByEmailQuery>;
export type UserByEmailLazyQueryHookResult = ReturnType<typeof useUserByEmailLazyQuery>;
export type UserByEmailQueryResult = Apollo.QueryResult<
  UserByEmailQuery,
  UserByEmailQueryVariables
>;
